export const cart = {
    namespaced: true,
    state: {
    },
    mutations: {
        initialiseStore(state) {
            if(sessionStorage.getItem('cart') && sessionStorage.getItem('cart') !== 'undefined') {
                Object.assign(state, JSON.parse(sessionStorage.getItem('cart')));
            }
        },
        commitStore(state) {
            Object.assign(state, state);
        },
        updateState(state, newState) {
            Object.assign(state, newState);
        },
        clearState(state) {
            this.replaceState({});
        }
    }
};
